<template>
  <div>
    <section class="status">
      <div class="date">
        <p class="name">{{ orderObtaining }} DATE</p>
        <p class="value">{{ date }}</p>
      </div>
      <div class="time">
        <p class="name">{{ orderObtaining }} TIME</p>
        <p class="value">{{ time }}</p>
      </div>
      <div class="payment">
        <p class="name">PAYMENT</p>
        <p class="value">{{ paymentType }}</p>
      </div>
    </section>

  </div>

</template>

<script>

export default {
  name: "confirmedStatusLocal",
  props: {
    isPaidByCC: Boolean,
    isDelivery: Boolean,
    time: String,
    date: String
  },
  computed: {
    paymentType() {
      return this.isPaidByCC ? "Paid with Credit Card" : "Pay in Store";
    },
    orderObtaining() {
      return this.isDelivery ? "DELIVERY" : "PICKUP";
    }

  }
};
</script>

<style lang="scss" scoped>

.status {
  display: grid;
  justify-content: space-between;
  padding: 0 3px;
  grid-template-areas: 'date time' 'payment payment';
  justify-items: center;
  width: 300px;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .status {
    grid-template-areas: 'date time payment';
    width: 500px;
  }
}

.date {
  grid-area: date;
}

.time {
  grid-area: time;
}

.payment {
  grid-area: payment;
}

.name {
  font-size: 14px;
  font-weight: bold;
  color: #a3a3a3;
  margin-bottom: 0;
}

.value {
  color: #212121;
  font-size: 16px;
  font-weight: bold;
}


</style>
